import {
  Box,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Field } from "formik";
import { renderTooltip } from "../../../../../components/RenderTooltip";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import { forNames } from "../../../../../utils/masks";
import { PopoverGenero } from "../../../../../components/PopoverGenero";
import { useState } from "react";
import CriancaService from "../../../../../../main/services/CriancaService";

export const ReferenciaFamiliarAba = ({ children, props, isMobile }) => {
  const [tipoReferencia, setTipoReferencia] = useState({
    options: [],
    isLoading: false,
  });
  const placement = useBreakpointValue({ md: "right" });
  const [isOpen, setIsOpen] = useState(false);
  const [hintSearch, setHintSearch] = useState(false);

  const handleGetTipoReferencia = () => {
    setTipoReferencia({ ...tipoReferencia, isLoading: true });
    CriancaService.getTipoReferencia().then((res) => {
      const allOption = { id: "", descricao: "Todos" };
      const formattedOptions = res.data.map((item) => ({
        label: item.descricao,
        value: item.id,
      }));
      setTipoReferencia({
        options: [allOption, ...formattedOptions],
        isLoading: false,
      });
    });
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Referência Familiar e Comunitária
        </Text>
        {children}
      </Flex>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Tipo de Referência Familiar
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 15, xl: 7, "2xl": 7 }} zIndex={"3"}>
            <Flex
              alignItems={props.errors.idTipoReferencia ? "center" : "end"}
              gap={2}
            >
              <CustomMultiSelectWField
                fieldName="idTipoReferencia"
                label="Selecione o Tipo de Referência Familiar"
                placeholder="Selecione o Tipo de Referência Familiar"
                getOptionLabel={(option) => option.label || option.descricao}
                getOptionValue={(option) => option.value}
                isLoading={tipoReferencia.isLoading}
                options={tipoReferencia.options}
                onChange={(value) => {
                  props.setFieldValue("idTipoReferencia", value);
                }}
                values={props?.values?.idTipoReferencia[0] || ""}
                onFocus={
                  tipoReferencia?.options?.length === 0
                    ? handleGetTipoReferencia
                    : null
                }
                visible
                todos
              />

              {props.values.idTipoReferencia && isMobile && (
                <PopoverGenero
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  handleClick={handleClick}
                  labelTextoGenero={
                    props.values?.idTipoReferencia?.label?.props?.children[1]
                      ?.props?.label
                  }
                />
              )}
            </Flex>
          </GridItem>
        </Grid>
      </Box>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Nome da Referência
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Grid
        templateColumns="repeat(15, 1fr)"
        gap="15px"
        mt="15px"
        w="100%"
        alignItems={"center"}
      >
        <GridItem colSpan={{ base: 15, xl: 7, "2xl": 7 }} zIndex={"2"}>
          <CustomInputWField
            fieldName="nomeReferencia"
            label="Pesquisar pelo Nome da Referência"
            placeholder="Digite o Nome"
            onChange={(e) =>
              props.setFieldValue("nomeReferencia", forNames(e.target.value))
            }
          />
        </GridItem>
      </Grid>

      <Flex gap={2} mt={7} mb={2}>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
        >
          Detalhamento de Irmãos
        </Text>
        {renderTooltip(
          isMobile,
          placement,
          "Habilitado somente se marcado Situação atual.",
          hintSearch,
          setHintSearch,
        )}
      </Flex>

      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box mt={7}>
        <Field name="detalhamentoIrmaos">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.detalhamentoIrmaos &&
                form.touched.detalhamentoIrmaos
              }
              id="detalhamentoIrmaos"
              width="100%"
              maxW="100%"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("detalhamentoIrmaos", value)
                }
              >
                <Stack flexDirection="column" gap={4}>
                  <Checkbox
                    id="checkbox-nome-social"
                    value="A"
                    isDisabled={props?.values?.tipoPeriodo === "D"}
                  >
                    Irmão(s) acolhido(s) no mesmo serviço de acolhimento.
                  </Checkbox>

                  <Checkbox
                    id="checkbox-nome-ficticio"
                    value="AD"
                    isDisabled={props?.values?.tipoPeriodo === "D"}
                  >
                    Irmão(s) acolhido(s) em serviço(s) de acolhimento
                    diferente(s).
                  </Checkbox>
                  <Checkbox
                    id="checkbox-data-nascimento"
                    value="H"
                    isDisabled={props?.values?.tipoPeriodo === "D"}
                  >
                    Irmão(s) sem histórico de acolhimento.
                  </Checkbox>
                  <Checkbox
                    id="checkbox-data-nascimento"
                    value="D"
                    isDisabled={props?.values?.tipoPeriodo === "D"}
                  >
                    Irmão(s) desligado(s).
                  </Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.detalhamentoIrmaos}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
